import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullFeedbackAlertComponent } from './full-feedback-alert.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerLocaleModule } from '../date-picker-locale/date-picker-locale.module';

@NgModule({
  declarations: [FullFeedbackAlertComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    DatePickerLocaleModule,
  ],
})
export class FullFeedbackAlertModule {}
